import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { submitWizardForm } from 'services/product';

import { CustomNotification } from 'common/components';
import { toggleReloadGridProduct } from 'pages/branded-products/controllers/actions';

export const useSubmitWizardForm = (options = {}) => {
  const dispatch = useDispatch();

  // Pulse the flag back to false so the next submit flips it again and reloads
  const reloadProductGrid = () => {
    dispatch(toggleReloadGridProduct(true));
    setTimeout(() => dispatch(toggleReloadGridProduct(false)), 100);
  };

  const {
    mutate: submitWizardFormMutation,
    mutateAsync,
    isLoading: isSubmitting,
  } = useMutation({
    ...options,
    mutationFn: (params) => submitWizardForm(params),
    onSuccess: (data, variables, context) => {
      if (data?.isSuccess) reloadProductGrid();

      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (error?.response?.data?.message) {
        CustomNotification.error(error.response.data.message);
      } else {
        CustomNotification.error('Failed to submit form');
      }

      if (options.onError) {
        options.onError(error, variables, context);
      }
    },
    onSettled: (data, error, variables, context) => {
      if (options.onSettled) {
        options.onSettled(data, error, variables, context);
      }
    },
  });

  return {
    isSubmitting,
    submitWizardFormMutation,
    submitWizardFormAsync: mutateAsync,
  };
};
